import { ReactNode } from "react";
import arrowIcon from "./images/chevron-right.svg";

/** Component which separates breadcrumb items. */
export const BreadcrumbItemSeparator = (): ReactNode => {
  return <img className="separator" src={arrowIcon} alt="Separator" />;
};
